/* Collection "Load more" — progressive enhancement (audit #13).
   Fetches the next paginated page and appends its product cards to the grid,
   keeping the numbered <nav class="pagination"> in the DOM for SEO / no-JS. */
(function () {
  var GRID = 'ul#main-collection-product-grid';

  function bind(btn) {
    if (btn.dataset.lmBound) return;
    btn.dataset.lmBound = '1';
    btn.addEventListener('click', onClick);
  }

  function init() {
    var btns = document.querySelectorAll('[data-load-more]');
    for (var i = 0; i < btns.length; i++) bind(btns[i]);
  }

  function onClick(e) {
    var btn = e.currentTarget;
    var url = btn.getAttribute('data-next-url');
    if (!url || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(GRID);
        var grid = document.querySelector(GRID);
        if (newGrid && grid) {
          while (newGrid.firstElementChild) {
            grid.appendChild(newGrid.firstElementChild);
          }
        }
        var nextBtn = doc.querySelector('[data-load-more]');
        var nextUrl = nextBtn && nextBtn.getAttribute('data-next-url');
        if (nextUrl) {
          btn.setAttribute('data-next-url', nextUrl);
        } else {
          var wrap = btn.closest('.load-more') || btn;
          wrap.parentNode && wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        // Fail soft: fall back to a normal page load.
        window.location.href = url;
      })
      .finally(function () {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('loading');
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
